import { useEffect } from 'react';
import type { VoidFunctionComponent } from 'react';
import type { SetState } from '../../../../types';
import type { AnyExportRequest } from '../../../../../shared/issuesV2';
import { useInputValue, useOnUnmount } from '../../../../hooks';
import { FormGroup, FormLabelVariant, LabeledTextArea, LabeledTextInput } from '../../../generic';

type Props = {
  setIsDisabled: SetState<boolean>;
  setContent: SetState<AnyExportRequest>;
};

const ManualLinkContent: VoidFunctionComponent<Props> = ({ setIsDisabled, setContent }) => {
  const [url, setUrl] = useInputValue('');
  const [comment, setComment] = useInputValue('');

  useEffect(() => {
    // Since each type of Issue Export has different criteria for when the submit button is disabled, we set it here
    // here for Manual tickets, when there is no URL.
    setIsDisabled(!url);

    setContent({
      type: 'custom',
      url,
      comment,
    });
  }, [comment, url, setContent, setIsDisabled]);

  // Reset the disabled state so that the other ticket creator can handle it.
  useOnUnmount(() => {
    setIsDisabled(false);
  });

  return (
    <FormGroup>
      <span>
        <LabeledTextInput
          label="URL"
          size="small"
          placeholder="https://..."
          onChange={setUrl}
          value={url}
          labelVariant={FormLabelVariant.Filter}
        />
        <span className="issues-modal__body__input-subtext">
          Link this issue to an existing ticket URL, e.g. a Github issue
        </span>
      </span>
      <LabeledTextArea
        label="Comment (optional)"
        onChange={setComment}
        value={comment}
        labelVariant={FormLabelVariant.Filter}
        placeholder="You can add a comment in FOSSA about the issue(s)"
      />
    </FormGroup>
  );
};

export default ManualLinkContent;
